import {
  selectIsAnalyticsDynamicHeatmapsFeatureFlagOn,
  selectIsDynamicContentReportingSnippetsFeatureFlagOn,
} from 'core/userContext';
import { createBrowserHistory } from 'history';
import { NBAContextProvider } from 'modules/ai/nba/context/NBAContextProvider';
import { MetricsContextProvider } from 'modules/productAnalytics/context';
import { useSelector } from 'react-redux';
import CampaignAnalytics from '../components/CampaignAnalytics';
import { CampaignAnalyticsDelivery } from '../components/Delivery';
import { CampaignAnalyticsEngagement } from '../components/Engagement';

import { DynamicHeatmap } from '../components/dynamicHeatmaps/DynamicHeatmap';
import Heatmap from '../components/Heatmap';
import { CampaignAnalyticsLocation } from '../components/Location';
import { Replies } from '../components/replies/Replies';
import { CampaignAnalyticsRetention } from '../components/Retention';
import { CampaignAnalyticsSegments } from '../components/Segments';
import { Snippets } from '../components/Snippets';
import { CampaignAnalyticsTimeSeries } from '../components/TimeSeries';
import { CAMPAIGN_ANALYTICS } from '../constants';
import { useWhatsAppGAFF } from '../hooks';
import { DynamicHeatmapContextProvider } from './DynamicHeatmapContextProvider';
import { FiltersContextProvider } from './FiltersContextProvider';
import { TimeFiltersContextProvider } from './TimeFiltersContextProvider';
import { UrlParamsContextProvider } from './UrlParamsContextProvider';

export const CampaignAnalyticsContext = () => {
  const history = createBrowserHistory();
  const isWhatsAppGAEnabled = useWhatsAppGAFF();
  const route = history.location.pathname;
  const isDCRFFOn = useSelector(selectIsDynamicContentReportingSnippetsFeatureFlagOn);
  const isDynamicHeatmapFFOn = useSelector(selectIsAnalyticsDynamicHeatmapsFeatureFlagOn);
  return (
    <MetricsContextProvider page={CAMPAIGN_ANALYTICS}>
      <UrlParamsContextProvider>
        <FiltersContextProvider>
          <TimeFiltersContextProvider>
            <NBAContextProvider>
              {
                {
                  '/analytics/campaignPerformance': <CampaignAnalytics />,
                  '/analytics/campaignPerformance/deliveries': <CampaignAnalyticsDelivery />,
                  '/analytics/campaignPerformance/engagement': <CampaignAnalyticsEngagement />,
                  '/analytics/campaignPerformance/retention': <CampaignAnalyticsRetention />,
                  '/analytics/campaignPerformance/segments': <CampaignAnalyticsSegments />,
                  '/analytics/campaignPerformance/timeSeries': <CampaignAnalyticsTimeSeries />,
                  ...(isDCRFFOn ? { '/analytics/campaignPerformance/snippets': <Snippets /> } : {}),
                  ...(isWhatsAppGAEnabled
                    ? { '/analytics/campaignPerformance/replies': <Replies /> }
                    : {}),
                  '/analytics/campaignPerformance/heatmap': isDynamicHeatmapFFOn ? (
                    <DynamicHeatmapContextProvider>
                      <DynamicHeatmap />
                    </DynamicHeatmapContextProvider>
                  ) : (
                    <Heatmap />
                  ),
                  '/analytics/campaignPerformance/locations': <CampaignAnalyticsLocation />,
                }[route]
              }
            </NBAContextProvider>
          </TimeFiltersContextProvider>
        </FiltersContextProvider>
      </UrlParamsContextProvider>
    </MetricsContextProvider>
  );
};
